import { CLASSES, ARIAS } from '../utils/constants';
import renderMinicart from '../lib/renderMinicart';
import { destroyMinicartDeliveryMessage } from '../lib/minicart-delivery';

const initMinicart = () => {
  const minicartToggles = document.querySelectorAll('[data-minicart-toggle]');
  const minicart = document.querySelector('[data-minicart]');
  const minicartCloseBtn = minicart?.querySelector('[data-minicart-close]');
  const minicartOverlay = document.querySelector('[data-minicart-overlay]');

  if (!minicartToggles.length || !minicart) return;

  const setMinicartState = (minicart, isOpen) => {
    minicart.classList.toggle('minicart-open', isOpen);
    minicartToggles.forEach(toggle => toggle.setAttribute(ARIAS.EXPANDED, isOpen));
    minicart.classList.toggle(CLASSES.TRANSLATE_X_0, isOpen);
    minicart.classList.toggle(CLASSES.TRANSLATE_X_100, !isOpen);

    if (!isOpen) destroyMinicartDeliveryMessage();
  };

  const open = () => setMinicartState(minicart, true);
  const toggle = (evt) => {
    evt.preventDefault();
    const isOpen = minicart.classList.contains('minicart-open');
    setMinicartState(minicart, !isOpen);
    minicartCloseBtn?.focus();
  };

  minicartToggles.forEach(minicartToggle => {
    if (minicartToggle.dataset.minicartToggleBound === 'true') return;

    minicartToggle.dataset.minicartToggleBound = 'true';
    minicartToggle.addEventListener('click', toggle);
  });
  if (minicartCloseBtn && minicartCloseBtn.dataset.minicartCloseBound !== 'true') {
    minicartCloseBtn.dataset.minicartCloseBound = 'true';
    minicartCloseBtn.addEventListener('click', toggle);
  }

  if (minicartOverlay && minicartOverlay.dataset.minicartOverlayBound !== 'true') {
    minicartOverlay.dataset.minicartOverlayBound = 'true';
    minicartOverlay.addEventListener('click', toggle);
  }

  window.theme.minicart = { open };

  renderMinicart();
};

export default initMinicart;
